import { temporarilyNotSupport } from '../../utils'

// 人脸识别
export const stopFaceDetect = /* @__PURE__ */ temporarilyNotSupport('stopFaceDetect')
export const initFaceDetect = /* @__PURE__ */ temporarilyNotSupport('initFaceDetect')
export const faceDetect = /* @__PURE__ */ temporarilyNotSupport('faceDetect')
